<footer>
  <section class="foot">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-3 col-lg-3">
          <img style="width:50%; margin-bottom: 20px;" src="assets/img/logo-white.png">
          <p style="font-size: 13px;">Groupe africain, géré par des africains, qui offre depuis plus de 18 ans un
            service d'expertise de qualité de dimension internationale.</p>
          <div class="social-footer">
            <a target="_blank" href="https://www.facebook.com/talentsplusafrique"><img
                src="assets/img/facebook1.svg"></a>
            <a target="_blank" href="https://www.linkedin.com/in/talents-plus-groupe-b325887a/"><img
                src="assets/img/linkedin1.svg"></a>
            <a target="_blank" href="https://twitter.com/TalentsPlus"><img src="assets/img/twitter1.svg"></a>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-lg-4 bot">
          <h3>Newsletter</h3>
          <div class="bar"></div>
          <p style="margin-top: 10px; font-size: 16px;">Inscrivez-vous pour ne rater aucune nouvelle sur nos produits
            & services</p>
          <form class="newsletter-footer" [formGroup]="newsletterForm" (ngSubmit)="onSubmitForm()">

            <div class="mb-3 col-md-12" style="padding: 0px !important;">


              <input class="form-control" formControlName="email" placeholder="Entrer votre email"
                onfocus="this.placeholder = ''" onblur="this.placeholder = 'Entrer votre email '" type="email">
            </div>
            <div class="mb-3 col-md-12" style="padding: 0px !important;">
              <button type="submit" class="btn btn-submit">Souscrire</button>
              <p class="text-danger" *ngIf="isLoading">Veuillez patienter...</p>
            </div>
          </form>
        </div>
        <div class="col-6 col-sm-3 col-lg-3 bot">
          <h3>En savoir plus</h3>
          <div class="bar"></div>
          <div style="margin-top: 10px">
            <a href="/a-propos/talents-plus-afrique#distinc"><img src="assets/img/chev.svg">Prix et Excellence</a>
            <a href=""><img src="assets/img/chev.svg">Références</a>
            <a href="/a-propos/talents-plus-afrique#partenaires"><img src="assets/img/chev.svg">Partenaires</a>
            <a href=""><img src="assets/img/chev.svg">Forum</a>
          </div>
        </div>
        <div class="col-6 col-sm-2 col-lg-2">
          <h3>Nous contacter </h3>
          <div class="bar"></div>
          <div style="margin-top: 10px">
            <a href="contact/benin-tpc"><img src="assets/img/benin.svg">Bénin</a>
            <a href="contact/cote-d-ivoire"><img src="assets/img/cote.svg">Côte d'ivoire</a>
            <a href="contact/mali"><img src="assets/img/togo.svg">Togo</a>
            <a href="contact/mali"><img src="assets/img/mali.svg">Mali</a>
          </div>
        </div>
        <div class="col-6" style="margin-top: 20px;">

        </div>
        <div class="hhr"></div>
        <div class="col-12 col-sm-6">
          <p style="color: #525252;text-align: center !important;">Copyright © 2022 Groupe Talents Plus, Tous droits
            réservés.
            Design by Talents Plus
            Afrique</p>
        </div>
        <div class="col-12 col-sm-6">
          <p style="color: #525252;"></p>
        </div>
      </div>
    </div>
  </section>
</footer>